import * as z from "zod";
import { mutator } from "./mutator";

/**
 * Per-link counterpart to `markWorkflowViewed`, keyed by `(user, workflow,
 * stepDir)`. Fires during normal navigation, so it uses `swallowError: true`
 * to no-op on a benign race (e.g. opening a link as its workflow is deleted)
 * rather than throw an OTel exception and roll back the optimistic mutation.
 */
export const markRouteViewed = mutator({
  schema: z.object({
    workflowId: z.string(),
    stepDir: z.string(),
    routeType: z.string().optional(),
    sourcePage: z.string().optional(),
  }),
  resolve: {
    workflow: {
      kind: "workflow",
      from: "workflowId",
      swallowError: true,
    },
  },
  permissions: [
    {
      permission: "space:read",
      scopeId: ({ args }) => args.workflow?.spaceId ?? null,
    },
  ],
  fn: async ({ tx, ctx, args: { workflow, stepDir } }) => {
    if (!workflow) return;
    const { userId } = ctx;
    await tx.mutate.routeViews.upsert({
      workflowId: workflow.id,
      userId,
      stepDir,
      lastSeenAt: Date.now(),
      tenantId: ctx.tenantId,
    });
  },
});
